import {
  BaSeContainer,
  BaSeErrorPage,
  BaSeLoadingSpinner,
} from '@base/react';
import React from 'react';
import { useCertificadoSituacaoService } from '../../hooks/certificado';
import {
  ContainerErro,
  ErrorWrapper,
  LoadingWrapper,
} from './visualizar-detalhe-erro-styled';

export const VisualizarDetalheErro = ({ id }) => {
  const [result, loading, error] = useCertificadoSituacaoService(id);

  return (
    <BaSeContainer delimitedOnBreakpoint="desktop">
      {loading && (
        <LoadingWrapper>
          <BaSeLoadingSpinner
            color="default"
            description="Carregando..."
            diameter={66}
            type="tertiary"
          />
        </LoadingWrapper>
      )}
      {error && (
        <ErrorWrapper>
          <BaSeErrorPage title="Algo deu errado" error="" />
        </ErrorWrapper>
      )}
      {!loading && !error && (
        <ContainerErro disabled readOnly >
          {result?.detalhe ?? 'Certificado sem detalhe de erro.'}
        </ContainerErro>
      )}
    </BaSeContainer>
  );
};
